module.exports = __webpack_public_path__ + "static/media/jibimo.1e6c3ae7.svg";